import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function Profile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get('/users/profile')
      .then(res => setUser(res.data))
      .catch(() => alert('Error al cargar perfil'));
  }, []);

  return (
    <div>
      <h2>Perfil</h2>
      {user ? (
        <pre>{JSON.stringify(user, null, 2)}</pre>
      ) : (
        <p>Cargando...</p>
      )}
    </div>
  );
}
